import { Component, Input } from '@angular/core';
import { CommonService } from '../../../services/common.service';
import { environment } from '../../../../environments/environment';
import { DefaultLayoutDirective } from '../../../flex-layout/custom-layout';
import { DefaultLayoutGapDirective } from '../../../flex-layout/custom-layout-gap';
import { DefaultFlexDirective } from '../../../flex-layout/flex';
import { NgOptimizedImageComponent } from '../ng-optimized-image/ng-optimized-image.component';
import { NgClass } from '@angular/common';
import { DefaultClassDirective } from '../../../flex-layout/class';
import { DefaultFlexAlignDirective } from '../../../flex-layout/flex-align';
import { DefaultLayoutAlignDirective } from '../../../flex-layout/custom-layout-align';
import { DefaultStyleDirective } from '../../../flex-layout/style';
import { MatButton } from '@angular/material/button';
import { EditorTextComponent } from '../editor-text/editor-text.component';
import { MatIcon } from '@angular/material/icon';
import { DefaultShowHideDirective } from '../../../flex-layout/show-hide';
import { SafePipe } from '../../pipes/safe.pipe';
import { MatTab, MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';

@Component({
  selector: 'calsoft-tab-layout',
  imports: [MatTabGroup, MatTab,  DefaultLayoutDirective, DefaultLayoutGapDirective, DefaultFlexDirective, NgOptimizedImageComponent, NgClass, DefaultClassDirective, DefaultFlexAlignDirective, DefaultLayoutAlignDirective, DefaultStyleDirective, MatButton, EditorTextComponent, MatIcon, DefaultShowHideDirective, SafePipe],
  templateUrl: './tab-layout.component.html',
  styleUrl: './tab-layout.component.scss'
})
export class TabLayoutComponent {

  @Input() item: any;

  @Input() data: any;

  @Input() categoryId: any;
  @Input() header: any;
  @Input() id: any;
  @Input() productImageHeight:any;
  @Input()  showCartIcon : any;
  @Input()  showCartIncremented : any;
  
  @Input() showConfigurableDropdown: any;
  @Input() urlNavigation: any=true;
  @Input() heightMobile: any;
  @Input() widthMobile: any;
  @Input() sortOrder: any;
  @Input() other: any;
  @Input() type: any="home";
  @Input() height: any;
  @Input() width: any;
  @Input() imageType: any; 
  @Input() slidesPerView: any;
  @Input() img: any;
  images: any; 

  public youtubeUrl = environment.youtubeUrl;

  public serverPath1 = environment.commonImageApi + '/commonSlider/';

  public serverPath = environment.commonImageApi + '/home/';
  defaultIndex: number | any;

  constructor( private commonService: CommonService,) { }

  index: number=0;

  showSecondDiv: boolean = false;

  toggleSecondDiv(index: number) {
   this.defaultIndex=index;
  }

  ngOnInit() {

    this.defaultIndex=0;
    this.toggleSecondDiv( this.defaultIndex);
    
  }
  
  onTabChange(event: MatTabChangeEvent): void {
   
    this.index=event.index
  }

  

  goToCategories(id: any) {
    if(id>0){
      this.commonService.goToCategory(1, parseInt(id));
    }

  }
  

  link(url: any ) {

    this.commonService.goToLink(url)
  }

	active: string |any;

  scrollDown(value: string, index: number) {
    this.active = value;
    this.defaultIndex = index; // Set the clicked button's index as the defaultIndex
    this.ScrollIntoView(this.active);
  }
  
	ScrollIntoView(elem: string) {
		this.active = "#" + elem;
		const ele = document.querySelector(this.active) as HTMLElement;
	  
		if (ele) {
		  const offsetTop = ele.getBoundingClientRect().top + window.pageYOffset;
      const paddingTop = 300;
		  window.scrollTo({
			top: offsetTop - paddingTop,
			behavior: 'smooth'
		  });
		} else {
		  console.error('Element not found:', this.active);
		}
	  }


}
